module.exports = __webpack_public_path__ + "static/img/t01.094dd0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/t01.jpg
// module id = RIgX
// module chunks = 1